export const DICTIONARY_OBJ = {
  text: {
    maxLength: 512,
  },
};
